//全局组件组件脚本
import LrCrud from "@/components/LrCrud";
import LrForm from "@/components/LrForm";
import LrInput from "@/components/LrInput";
import LrSelectTree from "@/components/LrSelectTree/SelectTree.vue";
// import LrChart from "@/components/LrChart";
import LrTree from "@/components/LrTree";
import LrDialog from "@/components/LrDialog";
import PageButton from "@/components/PageButton";
//机构树
import DeptTree from "@/components/LrOrganization/DeptTree";

//输入框、同时可多选
import LrSelectInput from "@/components/LrSelectInput/index";
//输入框、同时可多选选项
import LrSelectInputOption from "@/components/LrSelectInput/option";
// //机构树
// import DeptSelectTree from "@/components/LrOrganization/DeptSelectTree";
// //用户自己部门机构树
// import SelfDeptTree from "@/components/LrOrganization/SelfDeptTree";
// //数据权限机构机构树
import AuthDeptTree from "@/components/LrOrganization/AuthDeptTree";
// import WebsiteDeptTree from "@/components/LrOrganization/WebsiteDeptTree";
import UserDetail from "@/components/User/UserDetail";
import UserDetailDialog from "@/components/User/UserDetailDialog";
import LrUpload from "@/components/LrUpload";
// import LrNotice from "@/components/LrNotice/notice.vue";
// import AddUsers from "@/components/LrAddData/AddUsers.vue";
// import CreateMsg from "@/components/LrMsg/CreateMsg.vue";
// import SendMsg from "@/components/LrMsg/SendMsg.vue";
// import MsgDetail from "@/components/LrMsg/MsgDetail.vue";
// let components = { LrCrud, LrForm, LrInput, LrChart, LrTree, LrDialog, PageButton, LrSelectTree, SelfDeptTree, AuthDeptTree, WebsiteDeptTree, DeptTree, LrUpload, LrNotice, UserDetailDialog, DeptSelectTree, AddUsers,SendMsg,MsgDetail,CreateMsg}
let components = { LrUpload, LrCrud,LrForm, LrInput, LrSelectTree,LrDialog,AuthDeptTree,UserDetail,UserDetailDialog, PageButton,DeptTree,LrTree, LrSelectInput,LrSelectInputOption}

export default (Vue) => {
    Object.keys(components).forEach(key => {
        Vue.component(`${key}`, components[key])
    })
}


// WEBPACK FOOTER //
// ./src/utils/components.js